/**
 * @file Purchase Album PPA mode info.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ContentWrap from '../global/ContentWrap';
import Button from '../global/Button';
import {
  getFolderSubscriptionPrice,
  getPpaPrice,
} from '../../util/purchase-album';
import { formatPriceForDisplay } from '../../util/format-money';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    price_whole_album: PropTypes.shape({
      value: PropTypes.number,
    }),
    is_demo: PropTypes.bool.isRequired,
    subscription_album_folder: PropTypes.shape({
      price: PropTypes.shape({
        value: PropTypes.number,
      }),
    }),
  }),
  showPricing: PropTypes.bool,
};

const defaultProps = {
  album: {
    id: '',
    price_whole_album: {
      value: null,
    },
    is_demo: false,
    subscription_album_folder: {
      price: {
        value: null,
      },
    },
  },
};

const PurchaseAlbumPpaInfo = ({ album, showPricing }) => {
  const ppaPrice = getPpaPrice(album);
  const folderSubscriptionPrice = getFolderSubscriptionPrice(album);

  return (
    <div className="content-wrap-gray flex-auto">
      <ContentWrap>
        <h3 className="mb-3">Hi there, welcome to Waldo!</h3>

        <p className="mb-3">
          Looking for your photos? Let&rsquo;s get started!
        </p>

        <Button
          btnBlock
          to={`/purchase/album/${album.id}/faces`}
          className={classNames({
            'pl-3': true,
            'text-center': !showPricing,
            'text-left': showPricing,
          })}
        >
          Start adding faces
          {showPricing && (
            <span className="btn-addon">
              ${formatPriceForDisplay(ppaPrice || folderSubscriptionPrice)}
            </span>
          )}
        </Button>
      </ContentWrap>
    </div>
  );
};

PurchaseAlbumPpaInfo.propTypes = propTypes;
PurchaseAlbumPpaInfo.defaultProps = defaultProps;

export default PurchaseAlbumPpaInfo;
